import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ScheduleService } from 'src/app/_service/schedule.service';
import { AuthService } from 'src/app/_service/auth.service';
import { VesselService } from 'src/app/_service/vessel.service';
import { EquipmentService } from 'src/app/_service/equipment.service';
import { TranslateService } from '@ngx-translate/core';
import { eventForm } from 'src/app/_model/schedule';
import { getVesselData } from 'src/app/_model/vessel';

import * as routing from '../../../_model/routing';
import { STATUS } from '../../../_model/string_literal';

@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
  styleUrls: ['./event-dialog.component.css']
})
export class EventDialogComponent implements OnInit, OnDestroy {
  form = new eventForm;
  eventForm = this.form.defaultForm;
  myUserId: string;
  eventEdit = false;
  vesselList: getVesselData[] = [];
  vesselEquipList = [];
  newVesselList: any;
  currVessel: any;
  vesselDropdownTouched = false;
  equipDropdownTouched = false;
  currEquip: any;
  sendEmail = 0;

  constructor (
    public auth: AuthService,
    private scheduleService: ScheduleService,
    private vesselService: VesselService,
    private equipmentService: EquipmentService,
    private translate: TranslateService,
    public router: Router,
    public dialogRef: MatDialogRef<EventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.vesselList = this.vesselService.vesselList;
    this.myUserId = this.auth.userId;
    this.newVesselList = this.vesselList.map(v => {
      return {
        ...v,
        dispName: v.name || v.otherName,
      }
    });
    if (data) {
      this.eventEdit = true;
      this.currVessel = this.newVesselList.find((v: any) => v.id === data.extendedProps.vessel_id);
      this.equipmentService.getVesselEquipByVesselId(this.currVessel?.id).subscribe({
        next: (value: any) => {
          this.vesselEquipList = value?.data.filter((ve: any) => ve.status !== STATUS.DELETED)
            .filter((ve: any) => {
              const equip: any = this.equipmentService.equipList.find((e: any) => e.id === ve.equipmentId);
              const man: any = this.equipmentService.manufacturerList.find((m: any) => m.id === equip.manufacturerId);
              return man.name === "JRCS";
            });
          this.currEquip = this.vesselEquipList.find((e: any) => e.id === data.extendedProps?.product_id?.[0]);
        }
      });
      this.eventForm.patchValue({
        call_title: data.title,
        scheduled_time: this.convertToLocalTime(data.start),
        scheduled_duration: this.calculateTimeDifference(data.start, data.end),
        incident_details: data.extendedProps.incident_details,
      });
    }
  }
  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    
  }

  joinEvent() {
    this.router.navigate([routing.Meetings], { queryParams: { roomName: this.data.title }});
  }

  convertToLocalTime(isoString: string): string {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  calculateTimeDifference(startISO: string, endISO: string): number {
    const startDate = new Date(startISO);
    const endDate = new Date(endISO);
  
    const diffMilliseconds = endDate.getTime() - startDate.getTime(); // Difference in ms
    const diffMinutes = diffMilliseconds / (1000 * 60); // Convert ms to minutes
  
    return diffMinutes;
  }

  onSendEmailChange(event: any) {
    this.sendEmail = event.target.checked ? 1 : 0;
  }

  onVesselDropdownOpen() {
    this.vesselDropdownTouched = true;
  }

  onVesselSelected() {
    this.equipmentService.getVesselEquipByVesselId(this.currVessel?.id).subscribe({
      next: (value: any) => {
        this.vesselEquipList = value?.data.filter((ve: any) => ve.status !== STATUS.DELETED)
          .filter((ve: any) => {
            const equip: any = this.equipmentService.equipList.find((e: any) => e.id === ve.equipmentId);
            const man: any = this.equipmentService.manufacturerList.find((m: any) => m.id === equip.manufacturerId);
            return man.name === "JRCS" && !man.isCustom;
          });
      }
    });
  }

  onEquipDropdownOpen() {
    this.equipDropdownTouched = true;
  }

  onSubmit() {
    this.eventForm.get('user_id')?.setValue(this.myUserId);
    this.eventForm.get('vessel_id')?.setValue(this.currVessel?.id);
    this.eventForm.get('product_id')?.setValue([this.currEquip?.id]);
    this.eventForm.get('sendEmail')?.setValue(this.sendEmail);
    if (this.eventForm.invalid) {
      window.alert(this.translate.instant("formInvalid"));
      return;
    }
    const scheduledTime = this.eventForm.get('scheduled_time')?.value || new Date();
    const localTime = new Date(scheduledTime);
    this.eventForm.get('scheduled_time')?.setValue(localTime.toISOString());
    if (!this.eventEdit) {
      this.scheduleService.postSchedule(this.eventForm.value).subscribe({
        error: (err) => { window.alert(this.translate.instant("err")); },
        complete: () => {
          window.alert(this.translate.instant("created"));
          this.dialogRef.close()
        },
      });
    }
    else {
      this.scheduleService.updateSchedule(this.data.id, this.eventForm.value).subscribe({
        error: (err) => { window.alert(this.translate.instant("err")); },
        complete: () => {
          window.alert(this.translate.instant("updated"));
          this.dialogRef.close()
        },
      });
    }
  }

  onDelete() {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    if (this.checkDelete()) {
      this.scheduleService.deleteSchedule(this.data.id)
      .subscribe({
        error: () => {
          window.alert(this.translate.instant("err"));
        },
        complete: () => {
          window.alert(
            this.translate.instant("eventDeleted", {
              title: this.eventForm.value.call_title
            })
          );
          this.dialogRef.close();
        }
      });
    }
  }

  checkDelete() {
    if (window.confirm('Are you sure you want to delete this event?')) {
      return true;
    } else {
      return false;
    }
  }
}